import { Delete } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Box, Button, Card, CardActions, CardContent, CardHeader, Divider, Grid, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ConfirmDialog, UploadImageCard } from "src/_modules/common";
import { MapitPhoneInput, MapItTextField } from "src/components/common";
import { ROLES, USER_ROLES_TYPES } from "src/constants";

export default function ProfileBasicInfoCard({
    role,
    type,
    profile,
    onChange,
    validationErrors,
    onUpateProfile,
    loading,
    isSuccess,
    error,
    onDeleteUser,
    deleteLoading,
    deleteIsSuccess,
    deleteError,
    registeredBy,
    plan_name,
    accountIntegrationInfo = false,
    onExportMerchant
}) {
    console.log({
  loading,
  isSuccess,
  error,
});

    const { t } = useTranslation()
    const [open, setOpen] = useState(false)

    return (
        <>
            <ConfirmDialog
                open={open}
                onClose={() => setOpen(false)}
                confirmFn={onDeleteUser}
                loading={deleteLoading}
                isSuccess={deleteIsSuccess}
                error={deleteError}
                title="Warning"
                content="Are you sure you want to delete this user?"
            />
            <Card>
                <CardHeader
                    title={t("Profile")}
                    action={
                        role === ROLES.admin &&
                        <Stack direction="row" spacing={2}>
                            <LoadingButton onClick={() => setOpen(true)} color="error" variant="contained" startIcon={<Delete />}>
                                {t("Delete")}
                            </LoadingButton>
                            <Button onClick={onExportMerchant} variant="contained" color="success">{t("Excel")}</Button>
                        </Stack>
                    }
                />
                <Divider />
                <CardContent>
                    <Grid container spacing={3} alignContent="center">
                        <Grid item xs={12} sm={3} md={3}>
                            <UploadImageCard
                                title={t("Choose Logo")}
                                name="logo"
                                image={profile?.logo}
                                handleChange={onChange}
                                error={validationErrors?.logo ?? ''}
                            />
                        </Grid>
                        <Grid item xs={12} sm={9} md={9} >
                            <Grid container spacing={2}>
                                {profile?.role === ROLES.freelanceDriver
                                    &&
                                    <Grid item xs={12} md={6}>
                                        <MapItTextField
                                            label={t("Name")}
                                            size="small"
                                            name="name"
                                            value={profile?.name ?? ''}
                                            required={true}
                                            handleChange={onChange}
                                            error={validationErrors?.name ?? ""}
                                        />
                                    </Grid>
                                }
                                {profile?.role !== ROLES.freelanceDriver
                                    &&
                                    <Grid item xs={12} md={6}>
                                        <MapItTextField
                                            label={t("companyName")}
                                            size="small"
                                            name="companyName"
                                            value={profile?.companyName ?? ''}
                                            required={true}
                                            handleChange={onChange}
                                            error={validationErrors?.companyName ?? ""}
                                        />
                                    </Grid>
                                }
                                {profile?.role !== ROLES.freelanceDriver
                                    &&
                                    <Grid item xs={12} md={6}>
                                        <MapItTextField
                                            label={t("Manager Name")}
                                            size="small"
                                            name="managerName"
                                            value={profile?.managerName ?? ''}
                                            required={true}
                                            handleChange={onChange}
                                            error={validationErrors?.managerName ?? ''}
                                        />
                                    </Grid>
                                }
                                <Grid item xs={12} md={6}>
                                    <MapItTextField
                                        label={t("Email Address")}
                                        size="small"
                                        name="email"
                                        value={profile?.email ?? ""}
                                        required={true}
                                        handleChange={onChange}
                                        error={validationErrors?.email ?? ""}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <MapitPhoneInput
                                        label={t("Phone")}
                                        size="small"
                                        name="phone"
                                        value={profile?.phone ?? ""}
                                        handleChange={onChange}
                                        error={validationErrors?.phone ?? ""}
                                    />
                                </Grid>
                                {
                                    profile?.role === ROLES?.freelanceDriver &&
                                    <>
                                        <Grid item xs={12} md={6}>
                                            <MapItTextField
                                                label={t("Id number")}
                                                size="small"
                                                name="caseNumber"
                                                value={profile?.caseNumber ?? ""}
                                                required={true}
                                                handleChange={onChange}
                                                error={validationErrors?.caseNumber ?? ""}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <UploadImageCard
                                                title={t("Your license")}
                                                name="licensePhoto"
                                                image={profile?.licensePhoto}
                                                handleChange={onChange}
                                                error={validationErrors?.licensePhoto ?? ""}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <UploadImageCard
                                                title={t("Vehicle form photo")}
                                                name="vehicleFormPhoto"
                                                image={profile?.vehicleFormPhoto}
                                                handleChange={onChange}
                                                error={validationErrors?.vehicleFormPhoto ?? ""}
                                            />
                                        </Grid>
                                    </>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* {
                        accountIntegrationInfo && */}
                    <Grid container spacing={3} alignContent="center" sx={{ mt: 1 }}>
                        {
                            !!registeredBy &&
                            <Grid item xs={12} md={6}>
                                <Box display="flex" alignItems="center">
                                    <Typography variant="h4">{t("Account registration type")}</Typography>
                                    <span style={{ marginRight: 5, marginLeft: 5 }}>:</span>
                                    <Typography variant="h6" color="secondary">{!!registeredBy ? t(`registeredBy.${registeredBy}`) : t("Regular Account")}</Typography>
                                </Box>
                            </Grid>
                        }
                        {
                            !!plan_name &&
                            <Grid item xs={12} md={6}>
                                <Box display="flex" alignItems="center">
                                    <Typography variant="h4">{t("Plan")}</Typography>
                                    <span style={{ marginRight: 5, marginLeft: 5 }}>:</span>
                                    <Typography variant="h6" color="secondary">{plan_name}</Typography>
                                </Box>
                            </Grid>
                        }
                        {
                            (!!profile?.salla?.store_id || !!profile?.zid?.store_id || !!profile?.shopify?.shop || !!profile?.woocommerce?.storeUrl) &&
                            <Grid item xs={12} md={6}>
                                <Box display="flex" alignItems="center">
                                    <Typography variant="h4">{t("Integrated with")}</Typography>
                                    <span style={{ marginRight: 5, marginLeft: 5 }}>:</span>
                                    {!!profile?.salla?.store_id && <Typography variant="h6" color="secondary">{t("Salla")}</Typography>}
                                    {!!profile?.zid?.store_id && <Typography variant="h6" color="secondary">{t("Zid")}</Typography>}
                                    {!!profile?.shopify?.shop && <Typography variant="h6" color="secondary">{t("registeredBy.SHOPIFY")}</Typography>}
                                    {!!profile?.woocommerce?.storeUrl && <Typography variant="h6" color="secondary">{t("WOOCOMMERCE")}</Typography>}
                                </Box>
                            </Grid>
                        }
                    </Grid>
                    {/* } */}
                </CardContent>
                <Divider />
                <CardActions sx={{
                    display: "flex",
                    justifyContent: error || isSuccess ? "space-between" : "flex-end",
                    alignItems: 'center',
                }}>
                    {error && <Typography color='text.danger'>{t(error)}</Typography>}
                    {isSuccess && <Typography color='success.main'>{t("Done successfully")}</Typography>}
                    <LoadingButton
                        disabled={(role === ROLES.admin && profile?.role === ROLES.freelanceDriver) || type === USER_ROLES_TYPES.SUB_ADMIN}
                        variant="contained"
                        loading={loading}
                        onClick={onUpateProfile}>
                        {t("Update")}
                    </LoadingButton>
                </CardActions>
            </Card>
        </>
    )
}
